import { type RouteRecordRaw } from 'vue-router'
import {ROUTES} from '@myorg/type-lib'
import {PrivacyPolicyPage} from '@myorg/account-lib'

export const privacyRoute: RouteRecordRaw = {
    path: ROUTES.PRIVACY.PATH,
    name: ROUTES.PRIVACY.NAME,
    component: PrivacyPolicyPage,
}